module.exports = __webpack_public_path__ + "static/media/logo.b2e1daf1.svg";